import React from "react";
import InputMask from "react-input-mask";

const ICMaskInputDisplay = props => (
  <InputMask
    className={"insta-label no-border-mask " + props.className}
    readOnly={true}
    mask={props.mask}
    value={props.value}
    maskChar={null}
  ></InputMask>
);

export default ICMaskInputDisplay;
